<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- <div class="row">
        <div class="col-sm-8">
            <b-form-select @change="getAllSubs()" v-model="selectedStatus" :options="payoutStatus" class="mb-3" />
        </div>
    </div> -->
    <div v-if="nSubs" class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table align-middle table-nowrap table-hover">
                <thead class="table-light">
                  <tr>
                    <th scope="col">Store</th>
                    <th scope="col">Email</th>
                    <th scope="col">Created</th>
                    <!-- <th scope="col">Devices</th> -->
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="list in nSubs" :key="list.id">
                    <td>
                      <h5 class="font-size-14 mb-1">
                        <a href="#" class="text-dark">{{list.storeName}}</a>
                      </h5>
                      <p class="text-muted mb-0">{{list.number}}</p>
                    </td>
                    <td>{{list.email}}</td>
                    <td>{{list.created}}</td>
                    <!-- <td>{{list.connectedDevices.length}}</td> -->
                    <td>
                      <ul class="list-inline font-size-20 contact-links mb-0">
                        <li class="list-inline-item px-2">
                          <a v-b-tooltip.hover title="something else">
                            <i class="bx bx-user-circle"></i>
                          </a>
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import firebase from 'firebase/app';

export default {
    page: {
    title: "Stores",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
    components: {
    Layout,
    PageHeader,
  },
  data(){
      return {
          title: "Stores",
          items: [
        {
          text: "Merchants",
          href: "/",
        },
        {
          text: "Stores",
          active: true,
        },
      ],
      options: {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
      },
      nSubs: [],
    
      sortBy: "",
      sortDesc: false,
      currentPage: 1,
      perPage: 10,
      totalRows: 1,
      pageOptions: [10, 25, 50, 100],
      isLoading: false,
      fullPage: true,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#ffffff",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      filter: null,
      filterOn: [],
      }
  },
  methods: {
    
      onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async getAllSubs(merchId){
        this.nSubs = [];
      await firebase.firestore().collection("stores")
      .where("ownerId", "==", merchId)
      .orderBy("created", "desc")
    //   .where("status", "==", this.selectedStatus)
      .get().then((dataList)=>{
        // eslint-disable-next-line no-console
                        // console.log(this.selectedStatus);
        if(dataList.size > 0){
          var itemArray = [];
          dataList.docs.forEach((singleDoc)=>{
            var data = {
              id: singleDoc.id,
              created: singleDoc.data().created.toDate().toLocaleDateString("en-US", this.options),
              email: singleDoc.data().email,
              country: singleDoc.data().country,
              isEnabled: singleDoc.data().isEnabled,
              storeName: singleDoc.data().storeName,
              number: singleDoc.data().number ?? null,
              storeType: singleDoc.data().storeType,
              connectedDevices: singleDoc.data().connectedDevices ?? []
            }
            itemArray.push(data);
            this.nSubs = itemArray
          })
        }
      })
    },
    
  },
  computed: {
      rows() {
      return this.nSubs.length;
    },
  },
  mounted() {
    const url = new URL(window.location.href);
    if(url){
        var merchId = url.searchParams.get("merchId");
        if(merchId){
            this.getAllSubs(merchId);
        }
        
    }
  },
}
</script>

<style>

</style>